export default __webpack_public_path__ + "static/decorist-banner-504118f48c49cd1983be3d41644e523c.webp";